<template>
  <FlashSalesTag
    v-if="dealContent"
    :icon="dealContent.icon"
    :label="dealContent.label"
    :tooltip-text="dealContent.tooltipText"
  />
</template>

<script setup lang="ts">
import type { Component } from 'vue'

import FlashSalesTag from './FlashSales/components/FlashSalesTag.vue'

defineProps<{
  dealContent: {
    label: string
    icon: Component
    tooltipText?: string
  } | null
}>()
</script>
